var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{staticClass:"base-tabs",attrs:{"fixed-tabs":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.tabs),function(t,i){return _c('v-tab',{key:i,attrs:{"disabled":t.disabled}},[_c('span',{staticClass:"tab-header"},[_vm._v(_vm._s(t.title))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }